var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetPartnersCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0993 2.82786C10.2259 2.70124 10.3263 2.55091 10.3948 2.38547C10.4633 2.22003 10.4986 2.0427 10.4986 1.86363C10.4986 1.68456 10.4633 1.50723 10.3948 1.34179C10.3263 1.17635 10.2259 1.02602 10.0993 0.899398C9.97266 0.772773 9.82236 0.672329 9.65693 0.6038C9.49151 0.535271 9.31421 0.5 9.13516 0.5C8.95611 0.5 8.77881 0.535271 8.61339 0.6038C8.44797 0.672329 8.29766 0.772773 8.17105 0.899398L1.34412 7.7272L3.27233 9.65567L10.0993 2.82786Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34413 7.72705L0.5 10.4997L3.27234 9.65551M7.48934 1.58105L9.41755 3.50952",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetPartnersCopyIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_partners_copy_icon.2504cfc340af572c28c844f83eb93cb8.svg";
export { ForwardRef as ReactComponent };